import React from "react";
import Select from "react-select";
import { useWindowWidth } from "../../../../shared/components/hooks/useWindowWidth/useWindowWidth";
import { BRAND_PERFORMANCE_DISPLAY, BRAND_PERFORMANCE_FILTER_STYLES } from "../../constants";
import {
  starRatingDefaultResponse,
  starRatingTransactionResponse,
  performanceScreensConstants,
  screenSize,
  MENU_PLACEMENT,
  FILTER_LABEL,
} from "../../../admin-screens/constants";
import {
  Option,
  ValueContainer,
  CustomCheckbox,
} from "../../../../shared";
import CustomDateFilter from "../../../../shared/components/dateFilter/customDateFilter";

const { GUEST_SENTIMENTS, GUEST_TRANSACTION, TRANSACTION, SENTIMENT } =
  performanceScreensConstants;

const FilterComponent = (props) => {
  const {
    dateState,
    setDateState,
    selectedOption,
    setSelectedOption,
    selectedRatingOption,
    handleRatingOptionChange,
  } = props;


  const windowWidth = useWindowWidth();

  //Set Filter Value
  const handleFilterChange = (e) => {
    setSelectedOption(e);
  };

  return (
    <div className="container-fluid pt-3">
      <div className="notification-form shadow card px-3 mb-3">
        <div className="card-body py-4">
          <div className="d-flex">
            <CustomCheckbox
              name="transaction"
              value={GUEST_TRANSACTION}
              label={TRANSACTION}
              selectedOption={selectedRatingOption}
              labelClassNames="d-flex align-items-center mr20"
              inputClassNames="mr5"
              onChange={handleRatingOptionChange}
            />
            <CustomCheckbox
              name="sentiment"
              value={GUEST_SENTIMENTS}
              label={SENTIMENT}
              selectedOption={selectedRatingOption}
              labelClassNames="d-flex align-items-center mr20"
              inputClassNames="mr5"
              onChange={handleRatingOptionChange}
            />
          </div>
          <Select
            className={`star-ranking rounded bg-secondary bg-opacity-25 ${windowWidth > screenSize.TABLET ? "w-25" : "w-50"
              }`}
            name="star"
            value={selectedOption}
            options={
              selectedRatingOption === GUEST_SENTIMENTS
                ? starRatingDefaultResponse
                : starRatingTransactionResponse
            }
            components={{
              IndicatorSeparator: () => null,
              Option,
              ValueContainer: ValueContainer,
            }}
            isMulti
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            getOptionLabel={(option) => option.label}
            onChange={handleFilterChange}
            placeholder={FILTER_LABEL.ALL}
            isSearchable
            maxMenuHeight={BRAND_PERFORMANCE_DISPLAY.FILTER_MENU_HEIGHT}
            menuPlacement={BRAND_PERFORMANCE_DISPLAY.FILTER_MENU_PLACEMENT}
            styles={BRAND_PERFORMANCE_FILTER_STYLES}
          />
          <hr />
          <CustomDateFilter dateState={dateState} setDateState={setDateState} />
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
